import React from 'react'
import { LabelSetStatus } from '../services/labelService'

type IngestStep = 'idle' | 'uploading' | 'queued' | 'processing' | 'completed' | 'failed'

interface Props {
  isOpen: boolean
  onClose: () => void
  step: IngestStep
  status?: LabelSetStatus | null
}

const stepOrder: IngestStep[] = ['uploading', 'queued', 'processing', 'completed']

export default function LabelIngestProgressModal({ isOpen, onClose, step, status }: Props) {
  if (!isOpen) return null

  const currentIdx = step === 'failed' ? 2 : Math.max(0, stepOrder.indexOf(step))

  const StepDot = ({ idx, label }: { idx: number; label: string }) => (
    <div className="flex items-center">
      <div className={`w-3 h-3 rounded-full mr-2 ${idx < currentIdx ? 'bg-green-600' : idx === currentIdx ? 'bg-black' : 'bg-gray-300'}`}></div>
      <span className={`text-sm ${idx < currentIdx ? 'text-green-700' : idx === currentIdx ? 'text-black' : 'text-gray-500'}`}>{label}</span>
    </div>
  )

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">라벨 업로드 진행 상태</h3>
          {/* 닫기/숨기기 제거: 진행 중에는 사용자 행동 차단 */}
        </div>

        <div className="space-y-3 mb-4">
          <StepDot idx={0} label="파일 업로드" />
          <StepDot idx={1} label="작업 확인 중" />
          <StepDot idx={2} label={step === 'failed' ? '처리 실패' : '압축 해제 · 매칭'} />
          <StepDot idx={3} label="완료" />
        </div>

        <div className="p-3 rounded bg-gray-50 text-sm text-gray-700">
          {step === 'uploading' && <div>파일 업로드 중입니다...</div>}
          {step === 'queued' && <div>업로드가 접수되었습니다. 잡이 생성되었습니다...</div>}
          {step === 'processing' && (
            // total>0 = 매칭이 끝나 카운터가 확정된 상태 (매칭 전에는 총계가 0으로 유지됨)
            status && status.total > 0 ? (
              <div>
                라벨 저장 중... (총 {status.total} · 일치 {status.matched} · 불일치 {status.unmatched})
              </div>
            ) : (
              <div>처리 중입니다...</div>
            )
          )}
          {step === 'completed' && (
            <div className="text-green-700">처리가 완료되었습니다. (총 {status?.total ?? 0} · 일치 {status?.matched ?? 0} · 불일치 {status?.unmatched ?? 0})</div>
          )}
          {step === 'failed' && (
            <div className="text-red-700">처리 중 오류가 발생했습니다. 다시 시도하거나 로그를 확인해주세요.</div>
          )}
        </div>

        {/* 컨트롤 버튼 제거 */}
      </div>
    </div>
  )
}


